import { Role } from '@tendium/prom-types';
import { IUserName, MfaMode, IApiUser } from 'src/models/users/types';

export interface ICompanyUser extends IUserName {
  role: Role;
  roles: Role[];
  companyRole: string;
  isAdmin: boolean;
  mfaMode: MfaMode;
  inviteSent: boolean;
  createdOn: string;
}
export interface IApiCompanyUser extends IApiUser {
  role: Role;
  roles: Role[];
  companyRole: string;
  enabled: boolean;
  isAdmin: boolean;
  mfaMode: MfaMode;
  invitationReSent: boolean;
  createdOn: number;
}
export enum EmployeesColumnsName {
  userName = 'userName',
  status = 'status',
  role = 'role',
  mfaMode = 'mfaMode',
  quickActions = 'quickActions'
}
